import { PublishData, PublishStatus } from "@kaltura/mediaspace-shared-types";
import { Globe16Icon, Link16Icon, Lock16Icon, WarningTriangle16Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import LinkIndicator from "./LinkIndicator";
import NoLinkIndicator from "./NoLinkIndicator";

export interface PublishIndicatorProps {
    className?: string;
    publishData: PublishData;
    entryId: string;
    /**
     * If true, the indicator is always non-interactive (never a link)
     */
    nonInteractive?: boolean;
}

const baseClassName = "kms-ds-publish-indicator";

const PublishIndicator = (props: PublishIndicatorProps) => {
    const { className = "", publishData, entryId, nonInteractive } = props;

    const { status, showWarning } = publishData;

    const statusMap = {
        [PublishStatus.PRIVATE]: {
            icon: showWarning && !nonInteractive ? <WarningTriangle16Icon /> : <Lock16Icon />,
            label: translate("Private"),
        },
        [PublishStatus.UNLISTED]: {
            icon: showWarning && !nonInteractive ? <WarningTriangle16Icon /> : <Link16Icon />,
            label: translate("Unlisted"),
        },
        [PublishStatus.PUBLISHED]: {
            icon: showWarning && !nonInteractive ? <WarningTriangle16Icon /> : <Globe16Icon />,
            label: translate("Published"),
        },
    };

    const showAsLink = !nonInteractive && (showWarning || status === PublishStatus.PUBLISHED);

    return (
        <>
            {showAsLink && (
                <LinkIndicator
                    className={`${className} ${baseClassName} ${baseClassName}-link`}
                    icon={statusMap[status].icon}
                    label={statusMap[status].label}
                    entryId={entryId}
                    showWarning={showWarning}
                />
            )}

            {!showAsLink && (
                <NoLinkIndicator
                    className={`${className} ${baseClassName} ${baseClassName}-no-link`}
                    icon={statusMap[status].icon}
                    label={statusMap[status].label}
                />
            )}
        </>
    );
};

export default PublishIndicator;
